import React, { useEffect, useMemo, useState } from 'react';
import ModalTemplateB from '../../../components/_template/modal/ModalTemplateB';
import { Account } from '../../../assets/constant/accountManager.type';
import { logic } from '../../../../logic';
import { ConnectedWallet, Kit } from '../../../assets/constant/kit.type';
import importIcon from '../../../assets/images/icon-import.png';
import connectIcon from '../../../assets/images/icon-connect.png';
import { requestAddressToMetamask } from '../../../../modules/EQExtension/utils/messageUtils';
import PageLoading from '../../../components/_atom/loading/PageLoading';
import SelectAccount from './SelectAccount';

export const enum SELECT_ACCOUNT_STEP {
  SELECT_ACCOUNT_TYPE,
  SELECT_ACCOUNT,
}

const ACCOUNT_TYPES = [
  { id: 1, label: 'Import from Account Manager', description: "Make it even easier with EQ Hub's Account Manager" },
  {
    id: 2,
    label: 'Connect wallet service (e.g. Metamask)',
    description: 'Connect to your existing wallet service, such as Metamask',
  },
];

type ConnectWalletModalProps = {
  isOpen: boolean;
  closeModal: (connectedWallet?: ConnectedWallet) => void;
  setConnectedWallet: (connectedWallet: ConnectedWallet) => void;
  kitDetail?: Kit;
};
const ConnectWalletModal = (props: ConnectWalletModalProps) => {
  const { isOpen, closeModal, setConnectedWallet, kitDetail } = props;
  const [step, setStep] = useState<SELECT_ACCOUNT_STEP>(SELECT_ACCOUNT_STEP.SELECT_ACCOUNT_TYPE);
  const title = useMemo(() => {
    switch (step) {
      case SELECT_ACCOUNT_STEP.SELECT_ACCOUNT_TYPE:
        return 'Select to Connect Wallet';
      case SELECT_ACCOUNT_STEP.SELECT_ACCOUNT:
        return 'Select Account';
    }
  }, [step]);
  const onClosed = (connectedWallet?: ConnectedWallet) => {
    setStep(SELECT_ACCOUNT_STEP.SELECT_ACCOUNT_TYPE);
    closeModal(connectedWallet);
  };
  const connectAccount = async (account: Account) => {
    if (!account) {
      return;
    }
    const { result, error } = await logic.wallet.setConnectWalletData('accountManager', account.address, account.account_id, account.name);
    if (error) {
      return;
    }
    if (result) {
      const connectedWallet = {
        connectWalletType: 'accountManager',
        connectAddress: account.address,
        accountId: account.account_id,
        accountName: account.name,
      };
      setConnectedWallet(connectedWallet);
      onClosed(connectedWallet);
    }
  };
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(false);
  }, [isOpen]);
  return (
    <ModalTemplateB isOpen={isOpen} title={title} showDivideLine={false} onRequestClose={onClosed as any}>
      {loading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
        >
          <PageLoading style={{ height: 246 }} />
        </div>
      )}
      <div>
        {step === SELECT_ACCOUNT_STEP.SELECT_ACCOUNT_TYPE && (
          <SelectAccountType setConnectedWallet={setConnectedWallet} setStep={setStep} onClosed={onClosed} setLoading={setLoading} />
        )}
        {step === SELECT_ACCOUNT_STEP.SELECT_ACCOUNT && (
          <SelectAccount
            setStep={setStep}
            onClickSelect={connectAccount}
            onClosed={onClosed}
            kitId={kitDetail?.kit_id || kitDetail?.nft_kit_id}
            categoryIdentifier={kitDetail?.category_identifier}
            chainId={kitDetail?.chain_id}
            kitOwnerAddress={kitDetail?.admin_address}
          />
        )}
      </div>
    </ModalTemplateB>
  );
};

export default ConnectWalletModal;

const SelectAccountType = ({
  setConnectedWallet,
  setStep,
  onClosed,
  setLoading,
}: {
  setConnectedWallet: (connectedWallet: ConnectedWallet) => void;
  setStep: (step: SELECT_ACCOUNT_STEP) => void;
  onClosed: (connectedWallet?: ConnectedWallet) => void;
  setLoading: (loading: boolean) => void;
}) => {
  const getAddress = async () => {
    const { result, error } = await logic.wallet.getConnectWalletData();
    if (error) {
      return;
    }
    const connectedWallet = { ...result, accountId: result?.accountId || undefined };
    setConnectedWallet({ ...result, accountId: result?.accountId || undefined });
    return connectedWallet;
  };
  const connectWalletToMetamask = async () => {
    const result = await requestAddressToMetamask('metamask');
    if (result) {
      const connectedWallet = await getAddress();
      onClosed(connectedWallet);
    }
    setLoading(false);
  };
  const connectWalletToAccountManager = async () => {
    setStep(SELECT_ACCOUNT_STEP.SELECT_ACCOUNT);
  };
  return (
    <div style={{ width: 652 }}>
      {ACCOUNT_TYPES.map((accountType, index) => {
        return (
          <div
            key={index}
            onClick={async () => {
              if (accountType.id === 1) {
                await connectWalletToAccountManager();
              } else {
                setLoading(true);
                await connectWalletToMetamask();
              }
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 20,
              marginBottom: 20,
              padding: 40,
              borderRadius: 16,
              backgroundColor: '#E5E8EE80',
              cursor: 'pointer',
            }}
          >
            <img src={accountType.id === 1 ? importIcon : connectIcon} alt="icon" style={{ width: 52, height: 52, objectFit: 'contain' }} />
            <div>
              <div style={{ fontSize: 22, fontWeight: 500, lineHeight: '26px' }}>{accountType.label}</div>
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: '16px',
                  color: '#33373B',
                }}
              >
                {accountType.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
